import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { LabelEditorShellComponent } from './containers/label-editor-shell/label-editor-shell.component';

@NgModule({
  declarations: [
    LabelEditorShellComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    LabelEditorShellComponent,
    CommonModule
  ]
})
export class LabelEditorModule {
  constructor() {}
}
